import api from "@/api/axios";

const USER_SESSIONS_URL = "/user-sessions";

/**
 * Get full UserSession for a given user and session
 */
export const getUserSession = (userId, sessionId) =>
  api.get(`${USER_SESSIONS_URL}/${sessionId}/users/${userId}`);

// List all user sessions for a session (with role_name/team_name)
export const listUserSessions = (sessionId) =>
  api.get(`${USER_SESSIONS_URL}/${sessionId}/users`);

/**
 * Get team IDs for all users in a session (efficient batch operation)
 */
export const getUserTeamsForSession = (sessionId) =>
  api.get(`${USER_SESSIONS_URL}/${sessionId}/user-teams`);

/**
 * Update any field(s) of a UserSession (PATCH)
 * Accepts partial updates: e.g. { role_id, goal, evaluation, recommendation }
 */
export const updateUserSession = (userId, sessionId, updates) =>
  api.patch(`${USER_SESSIONS_URL}/${sessionId}/users/${userId}`, updates);

/**
 * Convenience helpers
 */
export const setUserSessionRole = (userId, sessionId, roleId) =>
  updateUserSession(userId, sessionId, { role_id: roleId });

export const setUserSessionTeam = (userId, sessionId, teamId) =>
  updateUserSession(userId, sessionId, { team_id: teamId });

export const setUserSessionGoal = (userId, sessionId, goal) =>
  updateUserSession(userId, sessionId, { goal });

export const setUserSessionEvaluation = (userId, sessionId, evaluation) =>
  updateUserSession(userId, sessionId, { evaluation });

export const setUserSessionRecommendation = (userId, sessionId, recommendation) =>
  updateUserSession(userId, sessionId, { recommendation });

export const getProfessorSessionOverview = () =>
  api.get(`${USER_SESSIONS_URL}/overview`);

export const getStudentSessionOverview = () =>
  api.get(`${USER_SESSIONS_URL}/me/overview`);
